import React from 'react'
import { HeaderPage } from '../../../components/HeaderPage'
import { ListOsc } from '../../../components/Osc/ListOsc'
import { AdminLayout } from '../../../layout/AdminLayout'

export const List = () => {

    return (
        <AdminLayout>
            <HeaderPage name='OSCs' />
            <ListOsc filter />
        </AdminLayout>
    )
}